/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartVennLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 5a7 7 0 0 1 0 14 1 1 0 0 1 0-2 5 5 0 0 0 0-10 1 1 0 0 1 0-2zM9 5c.599 0 1.316.144 2.129.413C9.195 6.876 8 9.354 8 12s1.195 5.124 3.129 6.587C10.316 18.856 9.599 19 9 19c-3.86 0-7-3.141-7-7s3.14-7 7-7zm3 2.263c1.248 1.115 2 2.868 2 4.737s-.752 3.622-2 4.738c-1.248-1.116-2-2.87-2-4.738s.752-3.622 2-4.737z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartVennLeft as ChartVennLeft };
